import loc from 'owa-localize';
import { favoritesDiagnosticDataDescription } from './favoritesDiagnosticStrings.locstring.json';
import { lazyRegisterDataCollectorIfNotRegistered } from 'owa-diagnostics-data-collection';
export async function registerDataCollector(): Promise<void> {
    const getFoldersDataCollector = {
        dataCollectionAction: getFolderFavoritessDataCollectionAction,
        name: 'OutlookFavorites',
        odsFileDescription: 'Favorites Data',
        description: loc(favoritesDiagnosticDataDescription),
    };
    await lazyRegisterDataCollectorIfNotRegistered.importAndExecute(getFoldersDataCollector);
}

const favoriteFoldersLog = new Map<string, string>();

export function setFolderFavoritesDataCollectionInformation(
    diagnostic: string,
    value: string
): void {
    favoriteFoldersLog.set(diagnostic, value);

    // Register the data collector to upload the favorites folders data response to logs if user reports an issue
    registerDataCollector();
}

function getFolderFavoritessDataCollectionAction(): Promise<string> {
    return Promise.resolve(JSON.stringify(Object.fromEntries(favoriteFoldersLog)));
}
